import React from 'react';

import Helmet from 'common/helmets/Helmet';

const Title = 'Jane Technologies Case Study | Canny';
const Description =
  'Read about how Jane Technologies streamlined user feedback and boosted company culture.';
const Image = 'https://canny.io/images/7bbea23270aac533fadddc907b49e1e7.jpg';

const JaneTechnologiesLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/case-studies/janetechnologies' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};

export default JaneTechnologiesLandingHelmet;
